import type { SearchResult } from '../../api/org';
import { Avatar } from '../../components/Avatar';
import { EmptyState } from '../../components/states';
import { usePersonDrawer } from '../../layout/shellContext';

export function SearchResults({
  result,
  onOpenDepartment,
}: {
  result: SearchResult;
  onOpenDepartment: (id: string) => void;
}) {
  const { open } = usePersonDrawer();
  if (!result.employees.length && !result.departments.length) {
    return (
      <section className="panel">
        <EmptyState title="Никого не нашли">Проверьте написание или ищите по должности и городу.</EmptyState>
      </section>
    );
  }
  return (
    <section className="panel page">
      {result.departments.length ? (
        <div className="pill-row">
          {result.departments.map((department) => (
            <button
              key={department.id}
              type="button"
              className="pill-toggle"
              onClick={() => onOpenDepartment(department.id)}
            >
              {department.name}
            </button>
          ))}
        </div>
      ) : null}
      {result.employees.length ? (
        <>
          <h2>Найдено: {result.employees.length}</h2>
          <div className="people-grid">
            {result.employees.map((person) => (
              <button key={person.id} type="button" className="person-card" onClick={() => open(person.id)}>
                <Avatar name={person.fullName} photoUrl={person.photoUrl} size="md" />
                <span className="text">
                  <b>{person.fullName}</b>
                  <small>{person.position ?? 'Должность не указана'}</small>
                  <small>{person.departments.join(' · ')}</small>
                </span>
              </button>
            ))}
          </div>
        </>
      ) : null}
    </section>
  );
}
